import {ListSharedValueObject} from '../../shared/ValueObjects/ListSharedValueObject.js'
import {FuelTypeSpecificationVehiclesValueObject} from './FuelTypeSpecificationVehiclesValueObject.js'

export class ListFuelTypesOptionsValueObject extends ListSharedValueObject {
  constructor({value}) {
    super({value})
  }

  static createFromApiResponse({items}) {
    this.validate({value: items})

    const fuelTypes = items.map(item =>
      FuelTypeSpecificationVehiclesValueObject.createFromLiterals({
        id: item.fuelTypeId,
        name: item.name
      })
    )

    return new ListFuelTypesOptionsValueObject({value: fuelTypes})
  }

  getFilterOptions() {
    return this.value.map(fuelType => {
      const {id, name} = fuelType
      return {
        id,
        value: id,
        label: name
      }
    })
  }
}
